import React, { useEffect, useState } from 'react'
import "./AccountDetailsTab.css"
import api from "../../../../../api/api";
import { useAuth } from '../../../../../features/auth/AuthContext';
import { useRef } from 'react';
import { toast } from "react-toastify";
import { account_balance, assured_workload, edit } from '../../../../../assets/images/images';
import { useSelector } from 'react-redux';
import { Visibility } from "../../../../../assets/images/images"
import { Tooltip } from "react-tooltip";


const ACCOUNT_TYPES_IN = ["Savings", "Current"];
const ACCOUNT_TYPES_STRIPE = ["Checking", "Savings"]; //bug fix 1889

/* ── Icons ── */


const AccountDetailsTab = () => {
    const { token } = useAuth()


    // ── Unified state for both India & Stripe fields ──
    const emptyForm = {
        // India fields
        accountHolderName: "",
        bank: "",
        phone: "",
        accountNumber: "",
        ifscCode: "",
        accountType: "",
        // Stripe fields
        bank_account_number: "",
        routing_number: "",
        account_holder_name: "",
        account_holder_type: "",
        account_type: "",
    };

    const [savedAccount, setSavedAccount] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [loading, setLoading] = useState(false);
    // const [toast, setToast] = useState({ visible: false, message: "", type: "" });
    const [form, setForm] = useState(emptyForm);
    const [ShowVarifyPopup, setShowVarifyPopup] = useState(false)
    const [amount1, setAmount1] = useState("");
    const [amount2, setAmount2] = useState("");
    const [accountDetails, setaccountDetails] = useState(null)
    const [banklist, setBanklist] = useState({})
    const [errors, setErrors] = useState({});
    const [apiError, setApiError] = useState("");
    const [showAccountNumber, setShowAccountNumber] = useState(false);
    const location = useSelector((state) => state?.globalState?.teacher_details?.data?.location);
    const [isUpdate, setIsUpdate] = useState(false);

    const getLocation = location ? location.split(",").pop().trim() : "";

    const [dummylocation, setDummylocation] = useState(accountDetails?.payment_gateway === "stripe" ? "USA" : "India")

    const Location = getLocation ? getLocation : "India";
    const isIndia = Location === "India";

    const isPayoutActive = localStorage.getItem("activePayoutId");

    // ── Validation per mode ──
    const isFormValid = isIndia
        ? (form.accountHolderName ?? "").trim() &&
        (form.phone ?? "").trim() &&
        form.bank &&
        (form.accountNumber ?? "").trim() &&
        (form.ifscCode ?? "").trim() &&
        form.accountType
        : (form.bank_account_number ?? "").trim() &&
        (form.routing_number ?? "").trim() &&
        (form.account_holder_name ?? "").trim() &&
        form.account_holder_type &&
        form.account_type;

    // const showToast = (message, type = "success") => {
    //     setToast({ visible: true, message, type });
    //     setTimeout(() => setToast({ visible: false, message: "", type: "" }), 3000);
    // };

    const handleEdit = () => {
        if (savedAccount) {
            setForm({ ...emptyForm, ...savedAccount });
        } else {
            setForm(emptyForm);
        }
        setIsEditing(true);
    };

    const handleCancel = () => setIsEditing(false);

    const handleChange = (field) => (e) => {
        let value = e.target.value;
        if (field === "accountNumber" || field === "bank_account_number" || field === "routing_number" || field === "phone")
            value = value.replace(/\D/g, "");
        if (field === "ifscCode") value = value.toUpperCase();
        setForm((prev) => ({ ...prev, [field]: value }));
        setErrors((prev) => ({ ...prev, [field]: "" }));
        setApiError("");
    };

    const validateForm = () => {
        const newErrors = {};

        if (isIndia) {
            if (!form.accountHolderName.trim())
                newErrors.accountHolderName = "Account holder name is required";
            else if (!/^[a-zA-Z\s]{3,}$/.test(form.accountHolderName.trim()))
                newErrors.accountHolderName = "Enter a valid full name (letters only)";

            if (!form.bank)
                newErrors.bank = "Please select a bank";

            if (!form.accountNumber.trim())
                newErrors.accountNumber = "Account number is required";
            else if (form.accountNumber.length < 9 || form.accountNumber.length > 18)
                newErrors.accountNumber = "Account number must be 9–18 digits";

            if (!form.ifscCode.trim())
                newErrors.ifscCode = "IFSC code is required";
            else if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(form.ifscCode))
                newErrors.ifscCode = "Invalid IFSC format (e.g. HDFC0001234)";

            if (!form.accountType)
                newErrors.accountType = "Please select an account type";
            if (!form.phone.trim())
                newErrors.phone = "Phone number is required";
            else if (!/^[6-9]\d{9}$/.test(form.phone.trim()))
                newErrors.phone = "Enter a valid 10-digit Indian mobile number";
        } else {
            if (!form.account_holder_name.trim())
                newErrors.account_holder_name = "Account holder name is required";

            if (!form.bank_account_number.trim())
                newErrors.bank_account_number = "Bank account number is required";
            else if (form.bank_account_number.length < 6)
                newErrors.bank_account_number = "Enter a valid account number";

            if (!form.routing_number.trim())
                newErrors.routing_number = "Routing number is required";
            else if (form.routing_number.length !== 9)
                newErrors.routing_number = "Routing number must be exactly 9 digits";

            if (!form.account_holder_type)
                newErrors.account_holder_type = "Please select account holder type";

            if (!form.account_type)
                newErrors.account_type = "Please select an account type";
        }

        setErrors(newErrors);
        toast.error(newErrors, {
            position: "top-center",
        })
        return Object.keys(newErrors).length === 0;
    };

    const handleSave = async () => {
        setApiError("");
        if (!validateForm()) return;

        let payload;
        setLoading(true);
        if (isIndia) {
            payload = {
                "bank_acc_no": form.accountNumber,
                "ifsc_code": form.ifscCode,
                "holder_name": form.accountHolderName,
                "phone": form.phone,
                "account_type": form.accountType,
                "bank_name": form.bank,
                "payment_gateway": "cashfree",
                // "update": isUpdate ? "true" : "false",
                "update": "true",



            }
        } else {
            payload = {
                "bank_account_number": form.bank_account_number,
                "routing_number": form.routing_number,
                "account_holder_name": form.account_holder_name,
                "account_holder_type": form.account_holder_type,
                "account_type": form.account_type,
                "payment_gateway": "stripe",
                // "update": isUpdate ? "true" : "false",
                                "update": "true",



            }
        }

        try {
            const response = await api.post(
                "/payouts/teacher/bank-account-details/add-verify/",
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Token ${token}`,
                    },
                }
            );

            const data = response;
            if (data) {
               // setIsUpdate(true);
                if (isIndia) {
                    //cashfree ->verify immidiatly 
                    await handleVerify()
                }
                else {
                    //stripe ->show verify popup for micro deposits ->then verify call
                    setShowVarifyPopup(true);
                }
            }

            setSavedAccount({ ...form });
            setIsEditing(false);
            toast.success("Bank account saved successfully!", {
                position: "top-center",
            })
        } catch (error) {
            const status = error?.response?.status;
            const serverMsg = error?.response?.data?.message || error?.response?.data?.detail;

            let errorMessage = "Something went wrong. Please try again.";

            if (status === 400) {
                errorMessage = serverMsg || "Invalid details. Please check and try again.";
            } else if (status === 401) {
                errorMessage = "Session expired. Please log in again.";
            } else if (status === 409) {
                errorMessage = "A bank account is already linked. Please remove it first.";
            } else if (status >= 500) {
                errorMessage = "Server error. Please try again later.";
            } else if (serverMsg) {
                errorMessage = serverMsg;
            }

            setApiError(errorMessage);
            toast.error(errorMessage, { position: "top-center" });
        } finally {
            setLoading(false);
        }
    };

    //og verify code 
    // const handleVerify = async () => {
    //     setLoading(true)
    //     let varifypayload;
    //     if (isIndia) {
    //         varifypayload = {
    //             "amount_1": "1",
    //             "amount_2": "1"
    //         }
    //     } else {
    //         varifypayload = {
    //             "amount_1": amount1,
    //             "amount_2": amount2
    //         }
    //     }
    //     try {
    //         const response = await api.post(
    //             "/payouts/teacher/bank-account-details/add-verify/",
    //             varifypayload,
    //             {
    //                 headers: {
    //                     "Content-Type": "application/json",
    //                     Authorization: `Token ${token}`,
    //                 },
    //             }
    //         );

    //         const data = response;
    //         setLoading(false)
    //         setIsEditing(false);
    //         toast.success("Bank account Verified successfully!", {
    //             position: "top-center",
    //         })
    //         setShowVarifyPopup(false)
    //     } catch {
    //         setLoading(false)
    //         setShowVarifyPopup(false)
    //         toast.error("Something went wrong in verifying. Please try again.", {
    //             position: "top-center",
    //         })
    //     } finally {
    //         setLoading(false); 
    //     }

    // }

    //new verify code :comment out veryfiy api only for cashfree.
    // const handleVerify = async () => {
    //     if (isIndia) {
    //         setShowVarifyPopup(false);
    //         return; // nothing to verify here for India
    //     }
    //     setLoading(true)
    //     let varifypayload;
    //     if (!isIndia) {
    //         varifypayload = {
    //             "amount_1": amount1,
    //             "amount_2": amount2
    //         }
    //     }
    //     try {
    //         const response = await api.post(
    //             "/payouts/teacher/bank-account-details/add-verify/",
    //             varifypayload,
    //             {
    //                 headers: {
    //                     "Content-Type": "application/json",
    //                     Authorization: `Token ${token}`,
    //                 },
    //             }
    //         );

    //         const data = response;
    //         setLoading(false)
    //         setIsEditing(false);
    //         toast.success("Bank account Verified successfully!", {
    //             position: "top-center",
    //         })
    //         setShowVarifyPopup(false)
    //     } catch {
    //         setLoading(false)
    //         setShowVarifyPopup(false)
    //         toast.error("Something went wrong in verifying. Please try again.", {
    //             position: "top-center",
    //         })
    //     } finally {
    //         setLoading(false);
    //     }

    // }


    //bhumesh 
    const handleVerify = async () => {
        let payload;
        setLoading(true);
        if (isIndia) {
            payload = {
                "bank_acc_no": form.accountNumber,
                "ifsc_code": form.ifscCode,
                "holder_name": form.accountHolderName,
                "phone": form.phone,
                "account_type": form.accountType,
                "bank_name": form.bank,
                "payment_gateway": "cashfree",
                // "update": isUpdate ? "true" : "false",
                                "update": "true",



            }
        } else {
            payload = {
                "bank_account_number": form.bank_account_number,
                "routing_number": form.routing_number,
                "account_holder_name": form.account_holder_name,
                "account_holder_type": form.account_holder_type,
                "account_type": form.account_type,
                "payment_gateway": "stripe",
                // "update": isUpdate ? "true" : "false",
                                "update": "true",



            }
        }
        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Token ${token}`,
                },
            };

            let response;

            if (isIndia) {
                // Cashfree: call verify API without payload
                response = await api.post(
                    "/payouts/teacher/bank-account-details/add-verify/",
                    payload,
                    config
                );
            } else {
                // Stripe: call verify API with micro-deposit amounts
                response = await api.post(
                    "/payouts/teacher/bank-account-details/add-verify/",
                    {
                        payload,
                        amount_1: amount1,
                        amount_2: amount2,
                    },
                    config
                );
            }

            toast.success("Bank account verified successfully!", {
                position: "top-center",
            });

            // setShowVarifyPopup(false);
            handleCancelVarifyPopup(); //PR1-I1872
            setIsEditing(false);
        } catch (error) {
            toast.error("Something went wrong in verifying. Please try again.", {
                position: "top-center",
            });
        } finally {
            setLoading(false);
        }
    };

    const hasChanges = savedAccount
  ? JSON.stringify(form) !== JSON.stringify({
      ...emptyForm,
      ...savedAccount,
    })
  : true; // Enable Save for a brand new account



    const getAccountDetails = async () => {
        setLoading(true)
        try {
            const response = await api.get(
                "/bank-account/details/",
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Token ${token}`,
                    },
                }
            );

            const data = response?.data?.data;
            
            //setIsUpdate(!!data); // true if data exists
            setLoading(false)
            setaccountDetails(data)
            setSavedAccount(
                isIndia
                    ? {
                        accountHolderName: data.holder_name ?? "",
                        phone: data.phone ?? "",
                        bank: data.bank_name ?? "",
                        accountNumber: data.bank_acc_no ?? "",
                        ifscCode: data.ifsc_code ?? "",
                        accountType: capitalize(data.account_type) ?? "",
                    }
                    : {
                        account_holder_name: data.holder_name ?? "",
                        account_holder_type: data.holder_type ?? "",
                        bank_account_number: data.bank_acc_no ?? "",
                        routing_number: data.routing_no ?? "",
                        account_type: capitalize(data.account_type) ?? "",
                    }
            );
            setIsEditing(false);


        } catch (error) {
            const status = error?.response?.status;
            if (status === 404) {
                setSavedAccount(null);
               // setIsUpdate(false)
            } else if (status === 401) {
                toast.error("Session expired Please login again ", {
                    position: "top-center",
                })
            } else {
                toast.error("Something went wrong", {
                    position: "top-center",
                })
            }

        } finally {
            setLoading(false);
        }
    }

    const handleCancelVarifyPopup = () => {
        setAmount1("");
        setAmount2("");
        setShowVarifyPopup(false)
    }

    const getBankList = async () => {
        try {
            const response = await api.get("/payouts/banks/", {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Token ${token}`,
                },
            })
            const bankList = response?.data;
            setBanklist(bankList)
            //console.warn("bank list", bankList);

        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        getAccountDetails()//fetch account details
    }, [])
    useEffect(() => {
        if (isIndia) {
            getBankList()
        }
    }, [getLocation])

    // const maskedAccount = savedAccount
    //     ? isIndia
    //         ? "XXXX XXXX XXXX " + savedAccount.accountNumber?.slice(-4)
    //         : "XXXX XXXX XXXX " + savedAccount.bank_account_number?.slice(-4)
    //     : "";

    //     const maskedAccount = savedAccount
    //     ? isIndia
    //         ? "XXXX XXXX XXXX " + (String(savedAccount.accountNumber ?? "").slice(-4) || "****")
    //         : "XXXX XXXX XXXX " + (String(savedAccount.bank_account_number ?? "").slice(-4) || "****")
    // : "";

    // const capitalize = (str) =>
    // str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : "";

    const displayAccount = savedAccount
        ? showAccountNumber
            ? isIndia
                ? savedAccount.accountNumber
                : savedAccount.bank_account_number
            : isIndia
                ? "XXXXXXXX" + (String(savedAccount.accountNumber ?? "").slice(-4) || "****")
                : "XXXXXXXX" + (String(savedAccount.bank_account_number ?? "").slice(-4) || "****")
        : "";

    const capitalize = (str) =>
        str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : "";

    const toggleAccountNumber = () => setShowAccountNumber(prev => !prev);


    return (
        <>
            <div className="page-wrapper">
                <div className="account-card">

                    {/* ── HEADER ── */}
                    <div className="card-header">
                        <span className="card-title">Your Account</span>
                        {!isEditing ? (
                            // <button className="btn-edit" onClick={handleEdit}>
                            //     <img src={edit} alt='edit' /> Edit
                            // </button>
                            <div
                                data-tooltip-id={isPayoutActive ? "edit-tooltip" : undefined}
                                style={{ display: "inline-block" }} key = "header-view"
                            >
                                <button
                                    className="btn-edit"
                                    onClick={handleEdit}
                                    disabled={!!isPayoutActive}
                                    style={{
                                        cursor: isPayoutActive ? "not-allowed" : "pointer",
                                        opacity: isPayoutActive ? 0.6 : 1,
                                    }}
                                >
                                    <img src={edit} alt="edit" /> Edit
                                </button>
                            </div>
                        ) : (
                            <div key = "header-edit" className="header-actionsb"> 
                                <button className="btn-cancelb" onClick={handleCancel} disabled={loading}>
                                    Cancel
                                </button>
                                <button
                                    className={`btn-save-header${isFormValid && hasChanges ? " active" : ""}`}
                                    onClick={handleSave}
                                    disabled={!isFormValid || loading || !hasChanges}
                                >
                                    {loading ? <span className="spinner" /> : "Save"}
                                </button>
                            </div>
                        )}
                    </div>
                    <Tooltip
                        id="edit-tooltip"
                        place="top"
                        content={`Payout is in progress.`}
                    />

                    {/* ── PAYMENT MODE BADGE ── */}
                    {/* <div className="payment-mode-badge">
                        <span className={`mode-pill ${isIndia ? "mode-india" : "mode-stripe"}`}>
                            {isIndia ? "🇮🇳 Indian Bank Transfer" : "🌐 Stripe (International)"}
                        </span>
                    </div> */}

                    {/* ══════════════════════════════════════════
              VIEW — has saved data
          ══════════════════════════════════════════ */}
                    {!isEditing && savedAccount && (
                        <>
                            <div className="details-grid">
                                {isIndia ? (
                                    <>
                                        <div className="detail-item">
                                            <span className="detail-value">Account Holder Name</span>
                                            <span className="detail-label">{savedAccount.accountHolderName}</span>
                                        </div>
                                        <div className="detail-item">
                                            <span className="detail-value">Bank</span>
                                            <div className="bank-name-row">
                                                <div className="bank-logo">
                                                    <span>{(savedAccount.bank ?? "??").slice(0, 2).toUpperCase()}</span>
                                                </div>
                                                <span className="detail-label">{(savedAccount.bank ?? "").toUpperCase()}</span>
                                            </div>
                                        </div>
                                        <div className="detail-item">
                                            <span className="detail-value mono">Account Number <img src={Visibility} alt="visibility" style={{ cursor: "pointer" }} onClick={toggleAccountNumber} /></span>
                                            <span className="detail-label">{displayAccount}</span>
                                        </div>
                                        <div className="detail-item">
                                            <span className="detail-value mono">IFSC Code</span>
                                            <span className="detail-label">{savedAccount.ifscCode}</span>
                                        </div>
                                        <div className="detail-item">
                                            <span className="detail-value">Account Type</span>
                                            <span className="detail-label">{savedAccount.accountType}</span>
                                        </div>
                                        <div className="detail-item">
                                            <span className="detail-value">Phone Number</span>
                                            <span className="detail-label">{savedAccount.phone}</span>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div className="detail-item">
                                            <span className="detail-value">Account Holder Name</span>
                                            <span className="detail-label">{savedAccount.account_holder_name}</span>
                                        </div>
                                        <div className="detail-item">
                                            <span className="detail-value">Account Holder Type</span>
                                            <span className="detail-label" style={{ textTransform: "capitalize" }}>
                                                {savedAccount.account_holder_type}
                                            </span>
                                        </div>
                                        <div className="detail-item">
                                            <span className="detail-value mono">Bank Account Number <span><img src={Visibility} alt="visibility" style={{ cursor: "pointer" }} onClick={toggleAccountNumber} /></span></span>
                                            <span className="detail-label">{displayAccount}</span>
                                        </div>
                                        <div className="detail-item">
                                            <span className="detail-value mono">Routing Number</span>
                                            <span className="detail-label">{savedAccount.routing_number}</span>
                                        </div>
                                        <div className="detail-item">
                                            <span className=" detail-value">Account Type</span>
                                            <span className="detail-label" style={{ textTransform: "capitalize" }}>
                                                {savedAccount.account_type}
                                            </span>
                                        </div>
                                    </>
                                )}
                            </div>
                            {
                                accountDetails?.is_verified === true &&
                                <div className="verified-row">
                                    <span className="verified-badge">
                                        <span className="icon-wrap"><img src={assured_workload} alt='acntsave' /></span>
                                        Account Verified
                                    </span>
                                </div>
                            }
                        </>
                    )}

                    {/* ── VIEW — no data yet ── */}
                    {!isEditing && !savedAccount && !loading && (
                        <>
                            <div className="details-grid">
                                {(isIndia
                                    ? ["Account Holder Name", "Bank", "Account Number", "IFSC Code", "Account Type", "Phone Number"]
                                    : ["Account Holder Name", "Account Holder Type", "Bank Account Number", "Routing Number", "Account Type"]
                                ).map((label) => (
                                    <div className="detail-item" key={label}>
                                        <span className="detail-label">{label}</span>
                                        <span className="detail-value na">NA</span>
                                    </div>
                                ))}
                            </div>
                            <div className="paused-notice">
                                <span>You can publish courses, but payouts are paused until bank details are verified.</span>
                            </div>
                        </>
                    )}

                    {/* ══════════════════════════════════════════
              EDIT / ADD FORM
          ══════════════════════════════════════════ */}
                    {isEditing && (
                        <>
                            <div className="form-grid">
                                {isIndia ? (
                                    /* ── INDIA FORM ── */
                                    <>
                                        <div className="form-group">
                                            <label className="form-label">Account Holder Name</label>
                                            <input
                                                className="form-input"
                                                type="text"
                                                placeholder="Full name"
                                                value={form.accountHolderName}
                                                onChange={handleChange("accountHolderName")}
                                            />
                                            {errors.accountHolderName && (
                                                <span className="field-error">{errors.accountHolderName}</span>
                                            )}
                                        </div>

                                        <div className="form-group">
                                            <label className="form-label">Bank</label>
                                            {/* <select
                                                className="form-select"
                                                value={form.bank}
                                                onChange={handleChange("bank")}
                                            >
                                                <option value="">Select Bank</option>
                                                {BANKS.map((b) => (
                                                    <option key={b} value={b}>{b}</option>
                                                ))}
                                            </select> */}
                                            <BankSearchDropdown
                                                banklist={banklist}
                                                value={form.bank}
                                                onChange={(name) => {
                                                    setForm((prev) => ({ ...prev, bank: name }));
                                                    setErrors((prev) => ({ ...prev, bank: "" }));
                                                }}
                                                error={errors.bank}
                                            />
                                        </div>

                                        <div className="form-group">
                                            <label className="form-label">Account Number</label>
                                            <input
                                                className="form-input"
                                                type="text"
                                                placeholder="Enter your account number"
                                                value={form.accountNumber}
                                                onChange={handleChange("accountNumber")}
                                                maxLength={18}

                                            />
                                            {errors.accountNumber && (
                                                <span className="field-error">{errors.accountNumber}</span>
                                            )}
                                        </div>

                                        <div className="form-group">
                                            <label className="form-label">IFSC Code</label>
                                            <input
                                                className="form-input"
                                                type="text"
                                                placeholder="Enter your IFSC code"
                                                value={form.ifscCode}
                                                onChange={handleChange("ifscCode")}
                                                maxLength={11}
                                            />
                                            {errors.ifscCode && (
                                                <span className="field-error">{errors.ifscCode}</span>
                                            )}
                                        </div>

                                        <div className="form-group">
                                            <label className="form-label">Account Type</label>
                                            <select
                                                className="form-select"
                                                value={form.accountType}
                                                onChange={handleChange("accountType")}
                                            >
                                                <option value="">Select account type</option>
                                                {ACCOUNT_TYPES_IN.map((t) => (
                                                    <option key={t} value={t}>{t}</option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="form-group">
                                            <label className="form-label">
                                                Phone Number
                                            </label>
                                            <input
                                                className="form-input"
                                                type="text"
                                                placeholder="10-digit mobile number"
                                                value={form.phone}
                                                onChange={handleChange("phone")}
                                                maxLength={10}
                                            />
                                            {errors.phone && (
                                                <span className="field-error">{errors.phone}</span>
                                            )}
                                        </div>
                                    </>
                                ) : (
                                    /* ── STRIPE FORM ── */
                                    <>
                                        <div className="form-group">
                                            <label className="form-label">Account Holder Name</label>
                                            <input
                                                className="form-input"
                                                type="text"
                                                placeholder="Full legal name"
                                                value={form.account_holder_name}
                                                onChange={handleChange("account_holder_name")}
                                            />
                                            {errors.account_holder_name && (
                                                <span className="field-error">{errors.account_holder_name}</span>
                                            )}
                                        </div>

                                        <div className="form-group">
                                            <label className="form-label">Account Holder Type</label>
                                            <select
                                                className="form-select"
                                                value={form.account_holder_type}
                                                onChange={handleChange("account_holder_type")}
                                            >
                                                <option value="" disabled>
                                                    Select Account Holder Type
                                                </option>
                                                <option value="individual">Individual</option>
                                                <option value="company">Company</option>
                                            </select>
                                        </div>

                                        <div className="form-group">
                                            <label className="form-label">Bank Account Number</label>
                                            <input
                                                className="form-input"
                                                type="text"
                                                placeholder="e.g. 000123456789"
                                                value={form.bank_account_number}
                                                onChange={handleChange("bank_account_number")}
                                                maxLength={17}
                                            />
                                            {errors.bank_account_number && (
                                                <span className="field-error">{errors.bank_account_number}</span>
                                            )}
                                        </div>

                                        <div className="form-group">
                                            <label className="form-label">Routing Number</label>
                                            <input
                                                className="form-input"
                                                type="text"
                                                placeholder="e.g. 110000000"
                                                value={form.routing_number}
                                                onChange={handleChange("routing_number")}
                                                maxLength={9}
                                            />
                                            {errors.routing_number && (
                                                <span className="field-error">{errors.routing_number}</span>
                                            )}
                                        </div>

                                        <div className="form-group">
                                            <label className="form-label">Account Type</label>
                                            <select
                                                className="form-select"
                                                value={form.account_type}
                                                onChange={handleChange("account_type")}
                                            >
                                                <option value="" disabled>
                                                    Select Account Type
                                                </option>
                                                {ACCOUNT_TYPES_STRIPE.map((t) => (
                                                    <option key={t} value={t} style={{ textTransform: "capitalize" }}>{t.charAt(0).toUpperCase() + t.slice(1)}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </>
                                )}
                            </div>

                            <div className="form-actions">
                                <button
                                    className="btn-save-account"
                                    onClick={handleSave}
                                    // disabled={!isFormValid || loading}
                                    disabled={!isFormValid || loading || !hasChanges} //for disable save button if no changes made
                                >
                                    {loading ? (
                                        <><span className="spinner" /> Saving...</>
                                    ) : (
                                        <> <img src={account_balance} alt='bankacnt' /> Save Account</>
                                    )}
                                </button>
                                <span className="save-hint">
                                    {isIndia
                                        ? ""
                                        : "Stripe will send micro-deposits to verify your account"}
                                </span>
                            </div>
                        </>
                    )}
                </div>

                {/* ── Demo Controls ── */}

                {/* 
                <div className="demo-controls">
                    <button
                        className="btn-demo"
                        onClick={() => { setSavedAccount(null); setIsEditing(false); }}
                    >
                        Reset (No Data)
                    </button>
                    <button
                        className="btn-demo"
                        onClick={() => {
                            setSavedAccount(
                                isIndia
                                    ? {
                                        accountHolderName: "Mrs. Polly Grey",
                                        bank: "Kotak Mahindra Bank",
                                        accountNumber: "12345678988864",
                                        ifscCode: "78995873489",
                                        accountType: "Savings Account",
                                    }
                                    : {
                                        account_holder_name: "Novesh",
                                        account_holder_type: "individual",
                                        bank_account_number: "000123456789",
                                        routing_number: "110000000",
                                        account_type: "checking",
                                    }
                            );
                            setIsEditing(false);
                        }}
                    >
                        Load Demo Data
                    </button>
                    <button onClick={getAccountDetails}>FETCH API AGAIN </button>
                </div> */}
            </div>

            {/* ── Toast ──
            <div className={`toast${toast.type ? ` ${toast.type}` : ""}${toast.visible ? " show" : ""}`}>
                {toast.message}
            </div> */}

            {
                ShowVarifyPopup && <>
                    <div className="modal-overlay">
                        <div className="verify-modal">
                            <h2 className="modal-title">Verify Bank Account</h2>

                            {/* <p className="modal-text">
                                Stripe sent two micro-deposits to Kotak Bank Acccount {bankAccountId}{" "}
                                on
                                {AmountCreditDate}. To verify this account confirm the amount of the
                                deposits.
                            </p> */}

                            <p className="modal-text">
                                Stripe sent two micro-deposits to Bank Acccount{" "}
                                on
                                CREDITDATE. To verify this account confirm the amount of the
                                deposits.
                            </p>

                            <p className="enter-text">Enter Amount</p>

                            <div className="amount-inputs">
                                <input
                                    type="text"
                                    value={amount1}
                                    onChange={(e) => setAmount1(e.target.value)}
                                    placeholder="$ 0.00"
                                />
                                <input
                                    type="text"
                                    value={amount2}
                                    onChange={(e) => setAmount2(e.target.value)}
                                    placeholder="$ 0.00"
                                />
                            </div>

                            <div className="modal-buttons">
                                <button className="cancel-btn" onClick={handleCancelVarifyPopup}>
                                    Cancel
                                </button>

                                <button
                                    className="verify-btn"
                                    onClick={handleVerify}
                                    disabled={!amount1 || !amount2}
                                >
                                    {loading ? <span className="spinner" /> : "Verify Account"}
                                </button>
                            </div>
                        </div>
                    </div>
                </>
            }
        </>
    );
};

const BankSearchDropdown = ({ banklist, value, onChange, error }) => {
    const [open, setOpen] = useState(false);
    const [search, setSearch] = useState("");
    const ref = useRef(null);

    // add useRef import at top if not already there
    const filtered = Array.isArray(banklist)
        ? banklist.filter((b) =>
            b.name.toLowerCase().includes(search.toLowerCase())
        )
        : [];

    const selected = Array.isArray(banklist)
        ? banklist.find((b) => b.name === value)
        : null;

    useEffect(() => {
        const handler = (e) => {
            if (ref.current && !ref.current.contains(e.target)) {
                setOpen(false);
                setSearch("");
            }
        };
        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, []);

    return (
        <div ref={ref} className="bank-dropdown-wrapper">
            <div
                className={`bank-dropdown-trigger ${open ? "open" : ""}`}
                onClick={() => setOpen((o) => !o)}
            >
                <span className={selected ? "trigger-value" : "trigger-placeholder"}>
                    {selected ? selected.name : "Select Bank"}
                </span>
                <span className="trigger-arrow">{open ? "▲" : "▼"}</span>
            </div>
            {error && <span className="field-error">{error}</span>}

            {open && (
                <div className="bank-dropdown-menu">
                    <div className="bank-search-box">
                        <input
                            autoFocus
                            type="text"
                            placeholder="Search bank..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            className="bank-search-input"
                        />
                    </div>
                    <ul className="bank-options-list">
                        {filtered.length === 0 ? (
                            <li className="bank-option-empty">No banks found</li>
                        ) : (
                            filtered.map((b) => (
                                <li
                                    key={b.id}
                                    className={`bank-option ${value === b.name ? "selected" : ""}`}
                                    onClick={() => {
                                        onChange(b.name);
                                        setOpen(false);
                                        setSearch("");
                                    }}
                                >
                                    {b.name}
                                </li>
                            ))
                        )}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default AccountDetailsTab;



//8 o clock: pending task :, varify api (after succesfully saved bank accont details) with POPUP , Error handling while saving bank details, dummy location correction , dummy is varified(revenuecomponent.jsx) , bank list api(by dipen )including search